import { useState } from 'react';
import { Button } from 'antd';
import { ClientInsuranceModal } from 'components/clients/client-insurance/components/client-insurance-modal';
import type { IInsuranceFormValues } from 'components/clients/client-insurance/components/client-insurance-modal';
import type { IClientInsuranceModalWithButtonProps } from './types';

export const ClientInsuranceModalWithButton = (props: IClientInsuranceModalWithButtonProps) => {
  const { buttonLabel, buttonProps, onSubmit, ...modalProps } = props;
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => setIsOpen(true);

  const handleClose = () => setIsOpen(false);

  const handleSubmit = async (values: IInsuranceFormValues) => {
    await onSubmit(values);
    handleClose();
  };

  return (
    <>
      <Button {...buttonProps} onClick={handleOpen}>
        {buttonLabel}
      </Button>
      <ClientInsuranceModal open={isOpen} onCancel={handleClose} onSubmit={handleSubmit} {...modalProps} />
    </>
  );
};
